<template>
  <div class="section-bottom-info" v-if="showSection">
    <p class="read-num" v-if="sectionData.click">阅读 {{sectionData.click | formatNumber}}</p>
    <template v-if="isConcept">
      <p class="post-time">{{sectionData.create_at | formateDate}}</p>
      <p class="post-addr" v-if="sectionData.ip_location">{{ '·' + sectionData.ip_location }}</p>
    </template>
  </div>
</template>
<script>
import FiltersMixin from '../mixins/filters-mixin'
export default {
  mixins: [FiltersMixin],
  props: {
    linkInfo: {
      type: Object,
      default: () => ({})
    },
    isConcept: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    showSection () {
      return this.linkInfo.click || (this.isConcept && (this.linkInfo.create_at || this.linkInfo.ip_location ))
    },
    sectionData () {
      return {
        click: this.linkInfo.click || undefined,
        create_at: this.linkInfo.create_at ,
        ip_location: this.linkInfo.ip_location 
      } 
    },
  }
}
</script>
<style lang="less">
.section-bottom-info {
  display: flex;
  align-items: center;
  padding: 6px 12px 12px;
  line-height: 16px;
  color: #8c9196;
  font-size: 10px;
  .read-num {
    margin-right: 5px;
  }
}
</style>